import { render, staticRenderFns } from "./ArredoclassicLogo.vue?vue&type=template&id=681ff73b&scoped=true&"
var script = {}
import style0 from "./ArredoclassicLogo.vue?vue&type=style&index=0&id=681ff73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ff73b",
  null
  
)

export default component.exports